module.exports = __webpack_public_path__ + "img/bikkurapon_icon.97498ba1.png";